import type { TCommunicationTemplate } from "@bbj-types/communication";
import { useCallback } from "react";
import { axiosCommunication } from "./axios";

export type TPostCommunicationTemplate = Pick<
  TCommunicationTemplate,
  "name" | "content" | "type" | "subject" | "feature" | "organisation"
>;

export const usePostCommunicationTemplate = () => {
  const [state, execute, cancel] = axiosCommunication<TCommunicationTemplate, TPostCommunicationTemplate, unknown>(
    {
      method: "POST",
      withCredentials: true,
    },
    { manual: true }
  );

  const callback = useCallback(
    (data: TPostCommunicationTemplate) => {
      return execute({
        url: "/templates",
        data,
      });
    },
    [execute]
  );

  return [state, callback, cancel] as const;
};
